/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Priority_PlaceholderInputs */

const en_explorer_info_priority_placeholder = /** @type {(inputs: Explorer_Info_Priority_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select priority (1-10)`)
};

const fr_explorer_info_priority_placeholder = /** @type {(inputs: Explorer_Info_Priority_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select priority (1-10)`)
};

const de_explorer_info_priority_placeholder = /** @type {(inputs: Explorer_Info_Priority_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select priority (1-10)`)
};

const it_explorer_info_priority_placeholder = /** @type {(inputs: Explorer_Info_Priority_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select priority (1-10)`)
};

const ru_explorer_info_priority_placeholder = /** @type {(inputs: Explorer_Info_Priority_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select priority (1-10)`)
};

const es_explorer_info_priority_placeholder = /** @type {(inputs: Explorer_Info_Priority_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select priority (1-10)`)
};

const zh_cn2_explorer_info_priority_placeholder = /** @type {(inputs: Explorer_Info_Priority_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select priority (1-10)`)
};

const ja_explorer_info_priority_placeholder = /** @type {(inputs: Explorer_Info_Priority_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select priority (1-10)`)
};

const hi_explorer_info_priority_placeholder = /** @type {(inputs: Explorer_Info_Priority_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select priority (1-10)`)
};

const pt_pt2_explorer_info_priority_placeholder = /** @type {(inputs: Explorer_Info_Priority_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select priority (1-10)`)
};

/**
* | output |
* | --- |
* | "Select priority (1-10)" |
*
* @param {Explorer_Info_Priority_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_priority_placeholder = /** @type {((inputs?: Explorer_Info_Priority_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Priority_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_priority_placeholder(inputs)
	if (locale === "de") return de_explorer_info_priority_placeholder(inputs)
	if (locale === "it") return it_explorer_info_priority_placeholder(inputs)
	if (locale === "ru") return ru_explorer_info_priority_placeholder(inputs)
	if (locale === "es") return es_explorer_info_priority_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_priority_placeholder(inputs)
	if (locale === "ja") return ja_explorer_info_priority_placeholder(inputs)
	if (locale === "hi") return hi_explorer_info_priority_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_priority_placeholder(inputs)
	return en_explorer_info_priority_placeholder(inputs)
});